import auth from "@/middleware/auth";

export default [
    {
        path: "resumoAcordoConsorcio",
        name: "resumoAcordoConsorcio",
        meta: { middleware: [auth] },
        component: () => import("./ResumoAcordoConsorcio")
    }
];
